export const messageStyles = {
  messageSkeleton: (isSender: boolean) => ({
    borderRadius: "32px",
    borderBottomLeftRadius: isSender ? "32px" : 0,
    borderBottomRightRadius: isSender ? 0 : "32px",
  }),
  imageMessage: (isMobile: boolean, isSender: boolean) => ({
    background: "#9b9b9b",
    display: "inline-block",
    width: isMobile ? "100%" : "300px",
    wordBreak: "break-word",
    fontSize: isMobile ? "13px" : "17px",
    fontWeight: "400",
    textAlign: "left",
    borderRadius: "32px",
    borderBottomLeftRadius: isSender ? "32px" : 0,
    borderBottomRightRadius: isSender ? 0 : "32px",
    cursor: "pointer",
  }),
  image: {
    height: 150,
    width: "100%",
    alignSelf: "center",
    marginBottom: "5px",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
  },
  itemDetailsText: {
    paddingX: "15px",
    textAlign: "left",
    fontSize: "13px",
    color: "#FFF",
    fontWeight: "500",
  },
  appText: {
    paddingX: "15px",
    textAlign: "left",
    fontSize: "11px",
    color: "#FFF",
    fontWeight: "400",
    marginBottom: "10px",
  },
  messageText: (isSender: boolean, isMobile: boolean) => ({
    backgroundColor: isSender ? "#5B9F5D" : "#E8E8EB",
    color: isSender ? "#ffffff" : "#0D0D0D",
    padding: "10px 15px",
    display: "inline-block",
    maxWidth: "550px",
    width: "auto",
    wordBreak: "break-word",
    fontSize: isMobile ? "13px" : "17px",
    fontWeight: "400",
    textAlign: "left",
    borderRadius: "32px",
    borderBottomLeftRadius: isSender ? "32px" : 0,
    borderBottomRightRadius: isSender ? 0 : "32px",
  }),
};
